// extracted by mini-css-extract-plugin
export default {"container":"PaymentResultPopup_container__oJ7H0","popup":"PaymentResultPopup_popup__cC-ux"};